import { gSP } from "app/blitz-server"
import SplashLayout from "app/core/layouts/Splash"

import Footer from "app/splash/components/Footer"
import Header from "app/splash/components/Header"
import Main from "app/splash/components/Main"
import contentful, { Post } from "integrations/contentful"

type Props = {
  post?: Post
}

const Home = ({ post }: Props) => {
  return (
    <>
      <Header />
      <Main post={post} />
      <Footer />
      {/* <Footer /> */}
    </>
  )
}

/*
const EmailInput: FC<{ feedbackString?:String }> = ({ feedbackString }) => {
  const { user, setUser } = useContext(UserContext);

  const [email, setEmail] = useState(undefined);
  const [resErrors, setResErrors] = useState<boolean>(false);

  const handleJoinWaitlistError = useCallback((err) => {
      setResErrors(true)
      setTimeout(() => {
          setResErrors(false)
      }, 2000)
      telemEvent("waitlist_signup", {
          validEmail: false,
          addedToWaitlist: false
      })
  },[])

  const onChange = event => setEmail(event.target.value)

  const _handleKeyDown = (e) => {
      if (e.key === 'Enter') {
          joinWaitList();
      }
    }

  const joinWaitList = useCallback(async () => {
      const res = await post(
          '/waitlist/create',
          {
              email: email,
              user_id: user.id
          },
          handleJoinWaitlistError
      )
      if(!res.corrupted){
          setUser( { ...user, email: res.email, isNewEmail: res.isNewEmail  } )
          telemEvent("waitlist_signup",  {
              validEmail: true,
              addedToWaitlist: res.isNewEmail
          })
          get('/go/open?path=/waitlist')
          get('/nav?down=j&up=k&see_request=enter')
      }
  },[user, email])

  return(
      <>
          <div className="place-self-center">
          <div className="max-w-sm pr-0 flex flex-nowrap items-center w-full place-self-center">
              <input
                  onChange={onChange}
                  onKeyDown={_handleKeyDown}
                  placeholder="Email"
                  className="text-primary-p2 bg-gray-600 appearance-none rounded shadow p-3  mr-4 focus:outline-none w-full flex-1"
                  autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck="false" />
              <button
                  style={{
                    background: 'linear-gradient(52deg, #FECA66 0%, #FECA66 0%, #FEA499 100%)'
                  }}
                  type="submit"
                  onClick={joinWaitList}
                  className="cta-btn p-3 flex-initial bg-primary-p9 hover:bg-primary appearance-none text-base font-medium tracking-wide p-3 rounded shadow focus:outline-none text-gray-800">
              Get Early Access →
              </button>
          </div>
          { resErrors ? <div className='transition flex justify-start mt-1'><p className="w-full text-left text-accent-right1"> Is that a valid email? 🤔 </p></div> : undefined }
          </div>

      </>
  )
}
*/

export const getStaticProps = gSP(async function getStaticProps({ params }) {
  const post = await contentful.getMostRecentPost()

  return {
    props: {
      post,
    },
    revalidate: 10,
  }
})

Home.suppressFirstRenderFlicker = true
Home.getLayout = (page) => <SplashLayout title="Superwall">{page}</SplashLayout>

export default Home
function pressNavLink(arg0: string): void {
  throw new Error("Function not implemented.")
}
